<script>
  export let gradientClass = "gradient-1";
  export let mainTitle = "";
  export let subTitle = "";
  export let info = " ";
  export let iconCls = "";
  export let iconColorCls = "text-white";

</script>
<div class={`card card-bx ${gradientClass}`}>
  <div class="card-body d-flex align-items-center">
    <div class="me-auto text-white">
      <h3 class="text-white">{mainTitle ?? ''}</h3>
      <span class="fs-16 fw-bold">{subTitle ?? ''}</span>
      <br />
      <span style="white-space: pre;" class="fs-12">{info}</span>
    </div>
    {#if iconCls}
    <i style="font-size: 3.5rem" class={`${iconCls} ${iconColorCls}`}></i>
    {/if}
    <slot />
  </div>
</div>
